<template>
  <div id="lautsprecher_id" class="lautsprecher z50 pointer active" v-bind:class="{muted:muted }" v-on:ClickLautsprecher="toggleMute" v-on:click="toggleMute" ref="lautsprecher">
    <img v-if="!muted" class="img" src="/static/assets/alle/Lautsprecher.png" />
    <img v-if="muted" class="img" src="/static/assets/alle/Lautsprecher_stumm.png" />
  </div>
</template>
<script>
/* eslint no-trailing-spaces: "off" */
window.$ = window.jQuery = require('jquery')
export default {
  name: 'Lautsprecher',
  data () {
    return {
      who: 'Lautsprecher',
      retval: 0,
      muted: false
    }
  },
  watch: {
    muted: function (oldval, newval) {
      console.log('watch muted: ', oldval, newval)
    }
  },
  methods: {
    toggleMute () {
      console.log('toggleMute')
      this.muted = !this.muted
      this.$root.muted = this.muted
      window.muted = this.muted
      window.localStorage.setItem('muted', this.muted)
      try {
        window.currentAudio.muted = window.muted
      } catch (e) {
      }
      try {
        window.currentAudioX.muted = window.muted
      } catch (e) {
      }
      try {
        window.hintergrundSound.muted = window.muted
      } catch (e) {
      }
    }
  },
  mounted () {
    var m = window.localStorage.getItem('muted')
    var muted  = false
    if (m === 'true') {
      muted = true
    }
    console.log('muted ausgelesen', muted)
    this.muted = muted
    this.$root.muted = muted
    window.muted = muted
    console.log('muted', muted)
    var elem = this.$refs.lautsprecher
    setTimeout(function() {
      elem.click()
      console.log('triggering click')
    }, 500)
    setTimeout(function() {
      elem.click()
      console.log('triggering click')
    }, 500)
  }

}
</script>
<style scoped>
/* Z-Index - Level */

.z1{z-index:10;}
.z2{z-index:20;}
.z3{z-index:30;}
.z4{z-index:40;}
.z5{z-index:50;}
.z6{z-index:60;}
.z7{z-index:70;}
.z8{z-index:80;}
.z9{z-index:90;}
.z10{z-index:100;}
.z11{z-index:110;}
.z12{z-index:120;}
.z13{z-index:130;}
.z14{z-index:140;}
.z15{z-index:150;}
.z16{z-index:160;}
.z17{z-index:170;}
.z18{z-index:180;}
.z19{z-index:190;}
.z20{z-index:200;}
.z21{z-index:210;}
.z22{z-index:220;}
.z23{z-index:230;}
.z24{z-index:240;}
.z25{z-index:250;}
.z26{z-index:260;}
.z27{z-index:270;}
.z28{z-index:280;}
.z29{z-index:290;}
.z30{z-index:300;}
.z31{z-index:310;}
.z32{z-index:320;}
.z33{z-index:330;}
.z34{z-index:340;}
.z35{z-index:350;}
.z36{z-index:360;}
.z37{z-index:370;}
.z38{z-index:380;}
.z39{z-index:390;}
.z40{z-index:400;}
.z41{z-index:410;}
.z42{z-index:420;}
.z43{z-index:430;}
.z44{z-index:440;}
.z45{z-index:450;}
.z46{z-index:460;}
.z47{z-index:470;}
.z48{z-index:480;}
.z49{z-index:490;}
.z50{z-index:500;}
.lautsprecher {position: absolute; left: 330px; bottom: 21px;}
</style>



// WEBPACK FOOTER //
// src/components/Lautsprecher.vue